<template>
  <div id="vendorOnboardingApp">
    <DashboardHeader
      heading="Settings"
      paragraph="Set up the main configuration of your directory."
    >
      <Button v-on:button-click="saveChanges" type="button">
        Save Changes
        <!-- <i class="fa fa-save ml-sm"></i> -->
      </Button>
    </DashboardHeader>
    <TabSelector
      :active="'Statuses'"
      :tabs="
        details.badgeReseller ? tabs : tabs.filter(tab => tab.name !== 'Badges')
      "
      spaced
    />
    <transition name="route">
      <router-view></router-view>
      <router-view name="filters"></router-view>
      <router-view name="urls"></router-view>
      <router-view name="branding"></router-view>
      <router-view name="code"></router-view>
      <router-view name="badges"></router-view>
      <router-view name="categoriesAndCollections"></router-view>
    </transition>
  </div>
</template>

<script>
import DashboardHeader from '@/components/Dashboard/DashboardHeader';
import TabSelector from '@/components/Dashboard/TabSelector';
import Button from '@/components/DesignSystem/Button';
import { mapGetters, mapActions } from 'vuex';

export default {
  components: {
    DashboardHeader,
    TabSelector,
    Button,
  },
  computed: {
    ...mapGetters(['details']),
  },
  data() {
    return {
      tabs: [
        {
          name: 'Tiers',
          path: '/settings',
        },
        {
          name: 'Filters',
          path: '/settings/filters',
        },
        {
          name: 'URLS',
          path: '/settings/urls',
        },
        {
          name: 'Logo & Color',
          path: '/settings/branding',
        },
        {
          name: 'HTML / CSS / JS',
          path: '/settings/code',
        },
        {
          name: 'Badges',
          path: '/settings/badges',
        },
        {
          name: 'Categories & Collections',
          path: '/settings/categoriesAndCollections',
        },
      ],
    };
  },
  created() {
    this.fetchTiers();
    this.fetchFilters();
    this.fetchDefaults();
    this.fetchUrls();
    this.fetchBranding();
    this.fetchCode();
    this.fetchBadges();
    this.fetchCategories();
    this.fetchCollections();
  },
  methods: {
    ...mapActions({
      fetchTiers: 'settings/tiers/fetchTiers',
      fetchFilters: 'settings/filters/fetchFilters',
      fetchUrls: 'settings/urls/fetchUrls',
      fetchBranding: 'settings/branding/fetchBranding',
      fetchCode: 'settings/code/fetchCode',
      fetchBadges: 'settings/badges/fetchBadges',
      fetchCategories: 'settings/categories/fetchCategories',
      fetchDefaults: 'settings/filters/fetchDefaults',
      fetchCollections: 'settings/collections/fetchCollections',
    }),
    saveChanges() {
      this.$store.dispatch('settings/saveChanges');
    },
  },
};
</script>

<style lang="scss" scoped>
.route-enter-active,
.route-leave-active {
  transition-duration: 0.1s;
  transition-property: all;
  transition-timing-function: ease;
}

.route-enter-active {
  transition-delay: 0.1s;
}

.route-enter,
.route-leave-active {
  opacity: 0;
}
</style>
